import { Button } from '@sketchnote/shared-components';
import React, { useState } from 'react';
import { API, endpoints } from 'src/api';

export const DeleteWorkspace = ({
  workspaceName,
  onClose,
  handleDeleteWorkspace,
}: {
  workspaceName: string;
  onClose: () => void;
  handleDeleteWorkspace: () => void;
}) => {
  const [name, setName] = useState('');
  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
  };

  return (
    <div>
      <p className="mb-16 text-gray-999 font-medium text-2xl">Delete confirmation</p>
      <p className="text-sm text-gray-600 mb-24">
        This action will permanently delete the workspace, associated data, and project for all
        users.
      </p>

      <p className="mb-24 text-lg text-gray-999">
        Confirm by typing {<span className="text-red-800">{workspaceName}</span>} below
      </p>
      <input
        className="h-48 bg-gray-100 rounded p-12 w-full mb-32 border"
        onChange={handleOnChange}
      />
      <div className="flex justify-end">
        <Button onClick={onClose} status={'secondary'} size="lg" className="justify-center mr-8">
          Cancel
        </Button>
        <Button
          disabled={workspaceName.length > 0 ? name.trim() != workspaceName.trim() : true}
          status={'primary'}
          size="lg"
          onClick={name.trim() != workspaceName.trim() ? undefined : handleDeleteWorkspace}
          className="justify-center"
        >
          Delete Workspace
        </Button>
      </div>
    </div>
  );
};
